import {
  Dispatch,
  MutableRefObject,
  SetStateAction,
  useEffect,
  useState,
} from "react";

const config: MutationObserverInit = {
  attributes: true,
  characterData: true,
  childList: true,
  subtree: true,
};

const useMutationObserver = (
  ref: MutableRefObject<HTMLElement | null>,
  mutationType: "attributes" | "childList" | "characterData" | "subtree"
): [boolean, Dispatch<SetStateAction<boolean>>] => {
  const [mutationDetected, setMutationDetected] = useState<boolean>(false);

  useEffect(() => {
    const callback = (mutationsList: MutationRecord[]) => {
      const mutationFound = Boolean(
        mutationsList.find((mutation) => mutation.type === mutationType)
      );
      if (mutationFound) {
        setMutationDetected(true);
        return;
      }
      return;
    };

    if (ref.current) {
      const observer = new MutationObserver(callback);

      observer.observe(ref.current, config);

      return () => {
        observer.disconnect();
      };
    }
  }, [mutationType, ref]);

  return [mutationDetected, setMutationDetected];
};

export default useMutationObserver;
